import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import TrustBar from './components/TrustBar';
import StatsSection from './components/StatsSection';
import WhyNeedSection from './components/WhyNeedSection';
import TrademarkTypesSection from './components/TrademarkTypesSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import RegistrationTimeline from './components/RegistrationTimeline';
import CTASection from './components/CTASection';
import TrademarkClassesSection from './components/TrademarkClassesSection';
import PricingSection from './components/PricingSection';
import ComparisonSection from './components/ComparisonSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const openForm = () => setIsContactFormOpen(true);

  return (
    <div className="bg-white">
      <Header onOpenContactForm={openForm} />

      <HeroBanner />

      <TrustBar />

      <StatsSection />

      <WhyNeedSection onOpenContactForm={openForm} />

      <TrademarkTypesSection />

      <HowWeWorkSection />

      <RegistrationTimeline />

      <CTASection
        onOpenContactForm={openForm}
        heading="Let's Register Your Trademark."
        buttonText="Start Registration Now"
        variant="purple"
      />

      <TrademarkClassesSection />

      <PricingSection onOpenContactForm={openForm} />

      <ComparisonSection onOpenContactForm={openForm} />

      <WhyChooseUsSection />

      <TestimonialsSection />

      <FAQSection onOpenContactForm={openForm} />

      <CTASection
        onOpenContactForm={openForm}
        heading="Your Brand Deserves Federal Protection."
        buttonText="Register Your Trademark"
        variant="teal"
      />

      <Footer onOpenContactForm={openForm} />

      <ContactFormDialog
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
      />

      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
